import { groupBy } from 'lodash';
import { ITypeTechnicalRoom } from 'pages/PageTypeTechnicalRoomPprList/interfaces';
import { IEquipmentType, IJournalEquipment, IJournalEquipmentItem } from './interfaces';

function groupByEquipmentTypeName(array: IJournalEquipmentItem[]): Record<string, IJournalEquipmentItem[]> {
  return groupBy(array, 'equipmentTypeName');
}

export function modifyJournalEquipment(
  typeTechnicalRooms: ITypeTechnicalRoom[],
  journalEquipment: IJournalEquipment | null,
): IJournalEquipment | null {
  if (!journalEquipment) return null;

  const initialJournalEquipmentItem: IJournalEquipmentItem = {
      equipment: null,
      equipmentCount: 0,
      equipmentCountry: '',
      equipmentModel: '',
      equipmentSerialNumberItem: '',
      equipmentSerialNumber: [],
      equipmentCost: 0,
      dateStart: null,
      monthCount: 0,
      comment: '',
      guaranteeMonth: 0,
    },
    equipmentTypesWithJournalEquipmentItem = (equipmentTypes: IEquipmentType[]) =>
      equipmentTypes.map((equipmentType) => ({ ...initialJournalEquipmentItem, ...equipmentType })),
    modifiedTypeTechinalRooms = typeTechnicalRooms.map(({ equipmentTypes, ...typeTechnicalRoom }) => ({
      typeTechnicalRoom,
      equipmentTypes: equipmentTypesWithJournalEquipmentItem(equipmentTypes || []),
    }));

  return {
    ...journalEquipment,
    modifiedItems: [
      {
        typeTechnicalRoom: null,
        equipmentTypes: {
          ...modifiedTypeTechinalRooms.reduce(
            (acc, curr) => Object.assign(acc, groupByEquipmentTypeName(curr.equipmentTypes)),
            {},
          ),
          ...groupByEquipmentTypeName(journalEquipment.item),
        },
      },
      ...modifiedTypeTechinalRooms.map(({ equipmentTypes, typeTechnicalRoom }) => ({
        typeTechnicalRoom,
        equipmentTypes: groupByEquipmentTypeName([
          ...journalEquipment.item.filter(
            ({ typeTechnicalRoomId }) => typeTechnicalRoomId === typeTechnicalRoom.typeTechnicalRoomId,
          ),
          ...equipmentTypes,
        ]),
      })),
    ],
  };
}
